import { useMutation } from "@apollo/client/react";

import FlashContext from "components/FlashMessages/FlashContext";
import useTypedContext from "hooks/useTypedContext";
import { WorkerPool } from "types/generated";
import { fileToBase64 } from "utils/file";

import { CREATE_WORKER_POOL } from "../gql";
import { CreateWorkerPoolFields } from "./types";
import { UNLIMITED_DRIFT_DETECTION_RUNS } from "./helpers";

const useCreateWorkerPool = () => {
  const { reportError } = useTypedContext(FlashContext);

  const [createWorkerPool] = useMutation<{ workerPoolCreate: WorkerPool }>(CREATE_WORKER_POOL, {
    refetchQueries: ["SearchWorkerPools"],
  });

  const onCreate = async (formData: CreateWorkerPoolFields) => {
    try {
      const base64 = await fileToBase64(formData.certificateFile as File);
      const certificateSigningRequest = base64 ? base64.toString().split(",")[1] : "";

      return createWorkerPool({
        variables: {
          name: formData.name,
          description: formData.description,
          certificateSigningRequest,
          labels: formData.labels.map((item) => item.value),
          space: formData.space,
          driftDetectionRunLimit: formData.driftDetectionRunLimit ?? UNLIMITED_DRIFT_DETECTION_RUNS,
        },
      });
    } catch {
      return reportError({
        message: `We couldn't create this workerpool. Please contact us at support or try to create it again.`,
      });
    }
  };

  return { onCreate };
};

export default useCreateWorkerPool;
